module.exports = __webpack_public_path__ + "static/media/bus-train-tram-2-svgrepo-com.bd6f24f4.svg";